import React from 'react'

const ByLandingPage = ({ landingPages, totalLeadsFromLpStats }) => {
    return (
        <div>
            <div className="card mb-2">
                <div className="align-items-center p-2 card-header">
                    <div className="font-weight-bold float-left">By Landing Page</div>
                </div>
                <div className="card-body p-2">
                    <table className="table table-card table-borderless table-striped table-hover">
                        <thead className="border-bottom">
                            <tr>
                                <th scope="col">Landing Page</th>
                                <th scope="col" className="text-right">
                                    Lead %
                                </th>
                                <th scope="col" className="text-right">
                                    EPC
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {landingPages.length === 0 ? (
                                <tr>
                                    <td colSpan={3}>No stats available</td>
                                </tr>
                            ) : (
                                landingPages.map((item, index) => (
                                    <tr key={`${index}-${item.lp_record_id}`}>
                                        <td>
                                            {item.lp_record_id} - {item.lp_name}
                                        </td>
                                        <td align="right">{totalLeadsFromLpStats > 0 ? Intl.NumberFormat('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format((item.lead_count / totalLeadsFromLpStats) * 100) : 0}%</td>
                                        <td align="right">${item.epc > 0 ? Intl.NumberFormat('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(item.epc) : 0.0}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default ByLandingPage

